export class WarrantyCreation {
    receiptOfGoodsId: string;
    receiptOfGoodsSkuId: string;
    accountNumber: string;
    companyName: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    email: string;
    orderNumber: string;
    manufacturerPartNumber: string;
    sku: string;
    parentSku: string;
    serialNumber: string;
    quantity: number;
    replacementNeeded: boolean = false;
    description: string;
    troubleshootTicketNumber: string;
    rmaNumber: string;
    addressOfDefective: string;
    addressToShipReplacement: string;
    addressOfDefectiveLine2 : string ;
    defectiveAddressCity : string ;
    defectiveAddressState : string ;
    addressToShipReplacementLine2 : string ;
    addressToShipReplacementCity : string ;
    addressToShipReplacementState : string ;
    addressToShipReplacementPostalCode : string;
    defectiveAddressPostalCode : string ;
    submittedByFirstName: string;
    submittedByLastName: string;
  }
  


// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/warranty.ts